import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.title',
		defaultMessage: 'Priority schemes',
		description: 'Page title for priority schemes global admin page',
	},
	addPriorityScheme: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.add-priority-scheme',
		defaultMessage: 'Add priority scheme',
		description: 'Button label for button to add a priority scheme',
	},
	isLockedTooltip: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.is-locked-tooltip',
		defaultMessage:
			'We’re updating a priority scheme and you can edit priority schemes after we’re done.',
		description: 'tooltip content to inform the user that this button is currently locked',
	},
	isHardLimitTooltip: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.is-hard-limit-tooltip',
		defaultMessage:
			'You cannot add more than {count, plural, one {# priority scheme} other {# priority schemes}}.',
		description:
			'tooltip content to inform users that the limit of priority schemes for this Jira instance has been reached',
	},
});
